export default ({
    selectedBusiness,
    selectedCampaign,
    selectedCreator,
    search,
    sortBy,
    allBusiness,
    medias,
    itemsPerPage,
    selectedMedias,
}) => ({
    selectedBusiness,
    selectedCampaign,
    selectedCreator,
    search,
    sortBy,
    allBusiness,
    medias,
    itemsPerPage,
    selectedMedias,
    downloading: false,
    removing: false,
    canOpenMediaContent: true,
    get sizeForHumans() {
        const bytes = this.selectedMedias.reduce((accumulator, media) => (accumulator += media.size), 0);

        return window.formatBytes(bytes);
    },
    get mediaIds() {
        return this.medias.map((media) => media.id);
    },
    get selectedQuantity() {
        return this.selectedMedias.length;
    },
    get selectedMediaIds() {
        return this.selectedMedias.map((media) => media.id);
    },
    get allSelected() {
        const selectedMediasIdsInCurrentPage = this.selectedMediaIds.filter((id) => this.mediaIds.includes(id));

        return (
            selectedMediasIdsInCurrentPage.length ===
            this.medias.filter((media) => media.url !== null && media.url !== "").length
        );
    },
    get currentPage() {
        const urlParams = new URLSearchParams(window.location.search);
        return parseInt(urlParams.get("page")) || 1;
    },
    urlIsFilled(media) {
        return media.thumbnail_url !== null && media.thumbnail_url !== "";
    },
    uniqueById(array) {
        return array.filter((value, index, self) => self.findIndex((v) => v.id === value.id) === index);
    },
    selectAll() {
        this.selectedMedias = this.uniqueById([
            ...this.selectedMedias.filter((media) => media.url !== null && media.url !== ""),
            ...this.medias.filter((media) => media.url !== null && media.url !== ""),
        ]);
    },
    unselectAll() {
        this.selectedMedias = this.selectedMedias.filter((media) => !this.mediaIds.includes(media.id));
    },
    openMediaContent({ index, mediaId = null }) {
        if (!this.canOpenMediaContent) {
            return;
        }

        this.canOpenMediaContent = false;

        const isFirstPage = this.currentPage === 1;
        let currentIndex = index;

        if (!isFirstPage) {
            currentIndex = currentIndex + (this.currentPage - 1) * this.itemsPerPage;
        }

        this.$dispatch("media-content::open", {
            absoluteIndex: currentIndex,
            mediaId,
            currentPage: this.currentPage,
            perPage: this.itemsPerPage,
            filters: {
                businessIds: this.selectedBusiness ? [this.selectedBusiness] : this.allBusiness,
                campaignId: this.selectedCampaign,
                creatorId: this.selectedCreator,
                search: this.search,
                sortBy: this.sortBy,
            },
        });

        setTimeout(() => (this.canOpenMediaContent = true), 1000);
    },
    async downloadMedias() {
        this.downloading = true;

        const medias = await this.$wire.call("downloadMedias", this.selectedMediaIds);

        if (medias === null) {
            this.downloading = false;
            return;
        }

        const response = await Promise.allSettled(medias.map((media) => this.fetchMediasAsBlob(media)));

        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

        for (const { status, value } of response) {
            if (status !== "fulfilled") {
                continue;
            }

            /*
             * Each browser has a limit of consecutive downloads.
             * We need to add a delay to bypass this limit.
             */
            await delay(250);

            const { blob, filename } = value;

            this.downloadMediaAsBlob(blob, filename);
        }
    },
    async handleRemoveMediaFiles() {
        this.removing = true;

        await this.$wire.call("removeMedias", this.selectedMediaIds);
    },
    async fetchMediasAsBlob(media) {
        const response = await fetch(media.url, {
            headers: {
                mode: "cors",
                credentials: "include",
                Pragma: "no-cache",
                "Cache-Control": "no-cache",
            },
        });

        if (!response.ok) {
            console.error(`Failed to fetch ${media.url}: ${response.statusText}`);
        }

        return {
            blob: await response.blob(),
            filename: media.name,
        };
    },
    downloadMediaAsBlob(blob, filename) {
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");

        a.href = url;
        a.download = filename;

        document.body.appendChild(a);

        a.click();

        document.body.removeChild(a);
    },
    handleMediaUploaded(event) {
        let medias = this.medias.map((media) => structuredClone(Alpine.raw(media)));

        const isFirstPage = this.currentPage === 1;

        if (event.detail.media.url) {
            window.toast({ message: "Media uploaded successfully!" });

            medias = medias.filter((media) => media.id !== event.detail.media.id);
        }

        medias.sort((firstMedia, secondMedia) => secondMedia.id - firstMedia.id);

        this.medias = medias;

        if (isFirstPage && (!this.selectedBusiness || this.selectedBusiness == event.detail.media.business_id)) {
            medias.length === 13 ? medias.pop() : null;
            medias.unshift(event.detail.media);
        }
    },
    mediaIsPhoto(media) {
        return media.type === "photo";
    },
    handleSelectedMediaChange(event, media) {
        if (this.selectedMediaIds.includes(media.id)) {
            this.selectedMedias = this.selectedMedias.filter((x) => x.id !== media.id);
            return;
        }

        this.selectedMedias.push(media);
    },
    dispatchHasMediaSelectedEvent() {
        this.$dispatch("has-media-selected", { hasMediaSelected: this.selectedMedias.length > 0 });
    },
    init() {
        this.$watch("selectedMedias", () => this.dispatchHasMediaSelectedEvent());

        this.dispatchHasMediaSelectedEvent();
    },
});
